// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sidebar_wrapper__MHV6U","footerLinks":"sidebar_footerLinks__jWfgU"};